import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPieChart1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconPieChart1"><Path d="M11.5 2.01233V12C11.5 12.2119 11.6336 12.4008 11.8334 12.4715L21.2525 15.8006C19.7565 19.4386 16.1774 22 12 22C6.47715 22 2 17.5229 2 12C2 6.64486 6.20944 2.27284 11.5 2.01233Z" fill="currentColor"/><Path d="M12.5 2.01233V11.6464L21.5857 14.8578C21.8553 13.9523 22 12.9931 22 12C22 6.64486 17.7906 2.27284 12.5 2.01233Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPieChart1;
